/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class ProductsGrid extends NoboxEntityGrid<ProductsRow, any> {
        protected getColumnsKey() { return ProductsColumns.columnsKey; }
        protected getDialogType() { return ProductsDialog; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getInsertPermission() { return ProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getService() { return ProductsService.baseUrl; }
        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();


            buttons.push({
                icon: "fa-download",
                title: "Product WA",
                hint: "Import WhatsApp Products",
                separator:true,
                onClick: () => {
                    var dlg = new ImportWAProductDialog();
                    dlg.loadNewAndOpenDialog();
                    dlg.clickAutoRefresh = () => {
                        this.element.find(".btn-autorefresh").click();
                    }
                }
            })
            return buttons;
        }


        constructor(container: JQuery) {
            super(container);
            Q.serviceCall({
                blockUI: true,
                url: "/Services/" + CustomFields.CustomfieldsService.baseUrl + "/Retrieve",
                request: {
                    EntityId: 2,
                },
                onSuccess: (res: Serenity.RetrieveResponse<CustomFields.CustomfieldsRow>) => {
                    $("#customFldProductData").val(res.Entity.Data);
                }
            })
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ProductsRow.Fields.Tags);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            }
        }
    }
}